@use '../../ui-library/styles/surface' as surface;

.pageWrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  background-color: surface.$surface-default;
}

.content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
